<template>
	<CRow>
		<CCol col="12" lg="12">
			<CAlert :color="messageColor" closeButton :show.sync="dismissCountDown" fade>
				{{ alertMessage }}
			</CAlert>

			<CCard>
				<CCardHeader>
					<strong>{{ $lang.advertisement.crud.edit }}</strong>
				</CCardHeader>

				<CForm novalidate @submit.prevent="onSubmit">
					<CCardBody>
						<CRow>
							<!-- Alumnies -->
							<CCol md="6">
								<div class="form-group"
									:class="{ 'form-group--error': $v.advertisement.alumnies.$error }">
									<label class="form__label">Alumnies
										<required_span />
									</label>
									<v-select :options="alumniesOptions" v-model="advertisement.alumnies" multiple
										@input="onAlumniesChange" />
									<small class="error" v-if="$v.advertisement.alumnies.$error">{{
										$lang.advertisement.validation.required.alumnies }}</small>
								</div>
							</CCol>

							<!-- User -->
							<CCol md="6">
								<div class="form-group" :class="{ 'form-group--error': $v.advertisement.userId.$error }">
									<label class="form__label">User
										<required_span />
									</label>
									<v-select :options="userOptions" v-model="advertisement.user"
										@input="onUserChange" />
                                    <small class="error" v-if="$v.advertisement.userId.$error">{{
										$lang.advertisement.validation.required.userId
									}}</small>
								</div>
							</CCol>

							<!-- Start Date -->
							<CCol md="6">
								<div class="form-group"
									:class="{ 'form-group--error': $v.advertisement.startDate.$error }">
									<label class="form__label">Start Date
										<required_span />
									</label>
									<input type="date" class="form-control" v-model="advertisement.startDate" />
									<small class="error" v-if="$v.advertisement.startDate.$error">{{
										$lang.advertisement.validation.required.startDate
									}}</small>
								</div>
							</CCol>

							<!-- End Date -->
							<CCol md="6">
								<div class="form-group"
									:class="{ 'form-group--error': $v.advertisement.endDate.$error }">
									<label class="form__label">End Date
										<required_span />
									</label>
									<input type="date" class="form-control" v-model="advertisement.endDate" />
									<small class="error" v-if="$v.advertisement.endDate.$error">{{
										$lang.advertisement.validation.required.endDate }}</small>
								</div>
							</CCol>

							<!-- Repeat -->
							<CCol md="6">
								<div class="form-group"
									:class="{ 'form-group--error': $v.advertisement.repeat.$error }">
									<label class="form__label">Repeat
										<required_span />
									</label>
									<v-select :options="repeatOptions" v-model="advertisement.repeat" @input="onRepeatChange" />
									<small class="error" v-if="$v.advertisement.repeat.$error">{{
										$lang.advertisement.validation.required.repeat }}</small>
								</div>
							</CCol>

							<!-- Media 1 Upload -->
							<CCol md="12">
								<CCard>
									<CCardHeader as="h5">Media - 1</CCardHeader>
									<CCardBody>
										<CRow>
											<CCol md="6">
												<div class="form-group"
													:class="{ 'form-group--error': $v.advertisement.buttonAlign.$error }">
													<label class="form__label">Button Align </label>
													<v-select :options="buttonAlignOptions"
														v-model="advertisement.buttonAlign" @input="onButtonAlignChange"/>
													<small class="error" v-if="$v.advertisement.buttonAlign.$error">{{
														$lang.advertisement.validation.required.buttonAlign }}</small>
												</div>
											</CCol>
											<CCol md="6">
												<div class="form-group"
													:class="{ 'form-group--error': $v.advertisement.buttonActionName.$error }">
													<label class="form__label">Button Action Name </label>
													<input type="text" name="ButtonActionName" class="form-control"
														v-model="advertisement.buttonActionName" />
													<small class="error"
														v-if="$v.advertisement.buttonActionName.$error">{{
															$lang.advertisement.validation.required.buttonActionName
														}}</small>
												</div>
											</CCol>
											<CCol md="12">
												<div class="form-group"
													:class="{ 'form-group--error': $v.advertisement.url.$error }">
													<label class="form__label">URL </label>
													<input type="url" class="form-control"
														v-model="advertisement.url" />
													<small class="error" v-if="$v.advertisement.url.$error">{{
														$lang.advertisement.validation.required.url }}</small>
												</div>
											</CCol>
											<CCol md="6">
												<div class="form-group">
													<label class="form__label">Image </label>
													<input class="form-control" type="file" @change="onFileChange"
														accept="image/*" />
												</div>
											</CCol>
											<CCol md="6">
												<div v-if="croppedImage" class="mt-4">
													<img :src="croppedImage" alt="Cropped" class="border" width="100"
														height="200" />
												</div>
												<!-- Crop Modals -->
												<CropModal v-if="showModal" :image-url="imageUrl" @crop="cropImage"
													@cancel="cancelCrop" />
											</CCol>
										</CRow>
									</CCardBody>
								</CCard>
							</CCol>
							<!-- Media 2 Upload -->
							<CCol md="12" v-if="croppedImage">
								<CCard>
									<CCardHeader as="h5">Media - 2</CCardHeader>
									<CCardBody>
										<CRow>
											<CCol md="6">
												<div class="form-group">
													<label class="form__label">Button Align </label>
													<v-select :options="buttonAlignOptions"
														v-model="advertisement.buttonAlign2" @input="onButtonAlignChange2"/>

												</div>
											</CCol>
											<CCol md="6">
												<div class="form-group">
													<label class="form__label">Button Action Name </label>
													<input type="text" class="form-control"
														v-model="advertisement.buttonActionName2" />
												</div>
											</CCol>
											<CCol md="12">
												<div class="form-group">
													<label class="form__label">URL </label>
													<input type="url" class="form-control"
														v-model="advertisement.url2" />
												</div>
											</CCol>
											<CCol md="6">
												<div class="form-group">
													<input type="file" @change="onFileChange2" accept="image/*" />
												</div>
											</CCol>
											<CCol md="6">
												<div v-if="croppedImage2" class="mt-4">
													<img :src="croppedImage2" alt="Cropped" class="border" width="100"
														height="200" />
												</div>
												<!-- Crop Modals -->
												<CropModal v-if="showModal2" :image-url="imageUrl2" @crop="cropImage2"
													@cancel="cancelCrop2" />
											</CCol>
										</CRow>
									</CCardBody>
								</CCard>
							</CCol>
							<!-- Media 3 Upload -->
							<CCol md="12" v-if="croppedImage2">
								<CCard>
									<CCardHeader as="h5">Media - 3</CCardHeader>
									<CCardBody>
										<CRow>
											<CCol md="6">
												<div class="form-group">
													<label class="form__label">Button Align </label>
													<v-select :options="buttonAlignOptions"
														v-model="advertisement.buttonAlign3" @input="onButtonAlignChange3"/>

												</div>
											</CCol>
											<CCol md="6">
												<div class="form-group">
													<label class="form__label">Button Action Name </label>
													<input type="text" class="form-control"
														v-model="advertisement.buttonActionName3" />
												</div>
											</CCol>
											<CCol md="12">
												<div class="form-group">
													<label class="form__label">URL </label>
													<input type="url" class="form-control"
														v-model="advertisement.url3" />
												</div>
											</CCol>
											<CCol md="6">
												<div class="form-group">
													<input type="file" @change="onFileChange3" accept="image/*" />
												</div>
											</CCol>
											<CCol md="6">
												<div v-if="croppedImage3" class="mt-4">
													<img :src="croppedImage3" alt="Cropped" class="border" width="100"
														height="200" />
												</div>
												<!-- Crop Modals -->
												<CropModal v-if="showModal3" :image-url="imageUrl3" @crop="cropImage3"
													@cancel="cancelCrop3" />
											</CCol>
										</CRow>
									</CCardBody>
								</CCard>
							</CCol>
						</CRow>
					</CCardBody>

					<CCardFooter>
						<CButton type="submit" size="sm" color="primary" :disabled="submitted">
							<CIcon name="cil-check-circle" /> {{ $lang.buttons.general.crud.submit }}
						</CButton>
						<CButton class="ml-2" color="danger" size="sm" @click="cancel">
							<CIcon name="cil-ban" /> {{ $lang.buttons.general.crud.cancel }}
						</CButton>
					</CCardFooter>

				</CForm>
			</CCard>
		</CCol>

	</CRow>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import { Mixin } from "/src/mixins/index.js";
import store from "/src/store/store.js";
import { advertisement } from "/src/store/url.js";
import CropModal from "./CropModal.vue";
import { CCol } from "@coreui/vue";

export default {
	name: "PostCreate",
	components: { required_span, CropModal },
	mixins: [Mixin],

	data() {
		return {
			self: this,
			json_data: [],
			json_label: {},
			json_title: "",
			messageColor: "success",
			alertMessage: "",
			showAlert: false,
			dismissCountDown: false,
			module: advertisement,
			submitted: false,
			alumniesOptions: [],
			userOptions: [],
			repeatOptions: [
				{ id: 0, label: "Per Day" },
				{ id: 1, label: "Week" },
				{ id: 2, label: "Month" },
				{ id: 3, label: "Year" },
			],
			buttonAlignOptions: [
				{ id: 1, label: "Top Left" },
				{ id: 2, label: "Top Center" },
				{ id: 3, label: "Top Right" },
				{ id: 4, label: "Middle Left" },
				{ id: 5, label: "Middle Center" },
				{ id: 6, label: "Middle Right" },
				{ id: 7, label: "Bottom Left" },
				{ id: 8, label: "Bottom Center" },
				{ id: 9, label: "Bottom Right" },
			],
			advertisement: {
				alumnies: [],
				alumniIds: [],
				user: null,
				userId: null,
				userType: null,
				startDate: null,
				endDate: null,
				repeat: null,
				repeatId: null,
				buttonAlign: null,
				buttonAlignId: null,
				buttonActionName: null,
				url: "",
				buttonAlign2: null,
				buttonAlignId2: null,
				buttonActionName2: null,
				url2: null,
				buttonAlign3: null,
				buttonAlignId3: null,
				buttonActionName3: null,
				url3: null,

			},
			imageUrl: null,
			croppedImage: null,
			showModal: false,

			imageUrl2: null,
			croppedImage2: null,
			showModal2: false,

			imageUrl3: null,
			croppedImage3: null,
			showModal3: false,
		};
	},

	validations: {
		advertisement: {
			alumnies: { required },
			userId: { required },
			startDate: { required },
			endDate: { required },
			repeat: { required },
			buttonAlign: { required },
			buttonActionName: { required },
			url: { required }
		},
	},
	mounted() {
		let self = this;
		store.commit('showLoader', false);
		self.dismissCountDown = false;
		localStorage.setItem("showAlert", "");

		// axios.get(self.module.api.collegeAlumniList).then((response) => {
		// 	const alumniData = response.data.data;
		// 	self.alumniesOptions = Object.entries(alumniData).map(([id, name]) => ({
		// 		id: id,
		// 		label: name,
		// 	}));
		// }).catch((error) => {
		// 	console.error("Failed to fetch college alumni list", error);
		// 	this.userOptions = [];
		// });

        axios.post(self.module.api.collegeAlumniList).then((response) => {
            self.alumniesOptions = response.data.data.map(alumniData => ({
                id: alumniData.id,
                label: alumniData.title,
            }));
        }).catch((error) => {
            console.error("Failed to fetch language", error);
            this.scholarshipTagsOption = [];
        });

        const id = this.$route.params.id;
        axios.get(this.viewUrlApi(this.module, id)).then((response) => {
			const resData = response.data.data;
			const advertise = resData.advertise;
			const user = resData.user;
            const media = resData.advertise_media;
            const alumni = resData.advertise_alumni;

            // console.log("0",media[0]?.image);
            // console.log("1",media[1]?.image);
            // console.log("2",media[2]?.image);
            if(media[1] != ""){
                self.croppedImage = true;
            }
            if(media[2] != ""){
                self.croppedImage2 = true;
            }

            const getOption = (options, id) => options.find(opt => opt.id === id) || null;

            self.advertisement.alumnies = alumni
                ? alumni.map(item => ({
                id: item.college_alumni_id,
                label: item.association_name
                }))
            : [];

            // Explicitly call onAlumniesChange to set alumniIds and fetch userOptions
            this.onAlumniesChange(this.advertisement.alumnies,user,advertise);
            
            this.advertisement.alumniIds = alumni.map(item => item.college_alumni_id);
            //this.advertisement.user = advertise.created_name;
            //this.advertisement.userId = advertise.user_id;
            //this.advertisement.userType = advertise.user_type;

            // // Now that userOptions are potentially loaded, set the selected user
            // if (advertise.user_id) {
            //     // Use $nextTick to ensure userOptions are fully rendered by v-select before setting
            //     this.$nextTick(() => {
            //         if (advertise.user_id) {
            //             // this.advertisement.user = selectedUserOption; // Set the full object for v-select
            //             // this.advertisement.userId = advertise.user_id;
            //             // this.advertisement.userType = advertise.user_type;
            //             this.advertisement.user = {
            //                 id: (user.user_id)?user.user_id:user.direct_candidate_id,
            //                 label: `${user.name}`,
            //                 userType: (user.user_id)?"User":"DirectCandidate",
            //             }
                        
            //         }
            //     });
            // }

            this.advertisement.startDate = advertise.start_date;
            this.advertisement.endDate = advertise.end_date;
            this.advertisement.repeat = this.repeatOptions.find(opt => opt.id === advertise.repeat);
            this.advertisement.repeatId = advertise.repeat;
            this.advertisement.buttonAlign = getOption(this.buttonAlignOptions, media[0]?.button_align) ?? null;
            this.advertisement.buttonAlignId = media[0]?.button_align ?? null;
            this.advertisement.buttonActionName = media[0]?.button_action_name ?? null;
            this.advertisement.url = media[0]?.url ?? null;


            this.advertisement.buttonAlign2 = getOption(this.buttonAlignOptions, media[1]?.button_align) ?? null;
            this.advertisement.buttonAlignId2 = media[1]?.button_align ?? null;
            this.advertisement.buttonActionName2 = media[1]?.button_action_name ?? null;
            this.advertisement.url2 = media[1]?.url ?? null;

            this.advertisement.buttonAlign3 = getOption(this.buttonAlignOptions, media[2]?.button_align) ?? null;
            this.advertisement.buttonAlignId3 = media[2]?.button_align ?? null;
            this.advertisement.buttonActionName3 = media[2]?.button_action_name ?? null;
            this.advertisement.url3 = media[2]?.url ?? null;


            this.croppedImage = media[0]?.image ?? null;
            this.croppedImage2 = media[1]?.image ?? null;
            this.croppedImage3 = media[2]?.image ?? null;

            console.log("this.advertisement",this.advertisement);
		}).catch((error) => {
			console.error("Failed to fetch college alumni list", error);
			this.userOptions = [];
		});
	},
	methods: {
		onAlumniesChange(selected,user=null,advertise=null) {
			let self = this;
			const alumniIds = selected.map(item => item.id);
			if (alumniIds.length) {
				self.advertisement.user = null;
				self.advertisement.userId = null;
				self.advertisement.alumniIds = alumniIds;
				axios.post(advertisement.api.userListByAlumnies, { alumni_ids: alumniIds }).then(response => {
					self.userOptions = response.data.data.map(user => ({
						id: (user.user_id)?user.user_id:user.direct_candidate_id,
						label: `${user.name}`,
                        userType: (user.user_id)?"User":"DirectCandidate",
					}));
                    if(user && advertise){
                        this.advertisement.user = {
                            id: (advertise.user_id)?advertise.user_id:user.id,
                            label: `${user.first_name}`,
                            userType: (advertise.user_type)?"User":"DirectCandidate",
                        }
                        this.advertisement.userId = (advertise.user_id)?advertise.user_id:user.id;
                        this.advertisement.userType = advertise.user_type;
                    }
				});
			} else {
				self.userOptions = [];
			}
		},
		onUserChange(selectedUser) {
			let self = this;
            console.log("selectedUser",selectedUser);
			if (selectedUser) {
				self.advertisement.userId = selectedUser.id;
				self.advertisement.userType = selectedUser.userType;
			} else {
				self.advertisement.userId = null;
                self.advertisement.userType = null;
			}
		},
        onRepeatChange(selected) {
			let self = this;
			if (selected) {
				self.advertisement.repeatId = selected.id;
			} else {
				self.advertisement.repeatId = null;
			}
		},
        onButtonAlignChange(selected) {
			let self = this;
			if (selected) {
				self.advertisement.buttonAlignId = selected.id;
			} else {
				self.advertisement.buttonAlignId = null;
			}
		},
        onButtonAlignChange2(selected) {
			let self = this;
			if (selected) {
				self.advertisement.buttonAlignId2 = selected.id;
			} else {
				self.advertisement.buttonAlignId2 = null;
			}
		},
        onButtonAlignChange3(selected) {
			let self = this;
			if (selected) {
				self.advertisement.buttonAlignId3 = selected.id;
			} else {
				self.advertisement.buttonAlignId3 = null;
			}
		},
		onSubmit() {
			let self = this;
			this.$v.advertisement.$touch();
			if (this.$v.advertisement.$invalid) {
				self.submitted = false; //Enable Button
			} else {
				self.submitted = false;
				const formData = new FormData();

				formData.append("alumniIds", self.advertisement.alumniIds);
				formData.append("user", self.advertisement.userId);
				formData.append("userType", self.advertisement.userType);
				formData.append("startDate", self.advertisement.startDate);
				formData.append("endDate", self.advertisement.endDate);
				formData.append("repeat", self.advertisement.repeatId);
				formData.append("buttonAlign", self.advertisement.buttonAlignId);
				formData.append("buttonActionName", self.advertisement.buttonActionName);
				formData.append("url", self.advertisement.url);
				formData.append("image", self.croppedImage);

				formData.append("buttonAlign2", self.advertisement.buttonAlignId2);
				formData.append("buttonActionName2", self.advertisement.buttonActionName2);
				formData.append("url2", self.advertisement.url2);
				formData.append("image2", self.croppedImage2);

				formData.append("buttonAlign3", self.advertisement.buttonAlignId3);
				formData.append("buttonActionName3", self.advertisement.buttonActionName3);
				formData.append("url3", self.advertisement.url3);
				formData.append("image3", self.croppedImage3);
                
                const editId = this.$route.params.id;
				axios.post(self.editUrlApi(self.module, editId), formData).then((response) => {
					if (response.data.code == 200) {
						self.alertMessage = response.data.message;
						self.dismissCountDown = 10;
                        this.$router.push({ path: "/advertisement" });
					} else {
                        self.submitted = false; //Enable Button
						(self.messageColor = "danger"),
                        (self.alertMessage = response.data.message);
						self.dismissCountDown = 10;
					}
				})
                .catch(function (error) {
                    self.submitted = false; //Enable Button
                    self.dismissCountDown = 10;
                });
			}
		},

		cancel() {
			this.$router.push({ path: "/advertisement" });
		},

		// IMAGE Upload Handlers
		onFileChange(e) {
			this.loadImage(e, 'imageUrl', 'showModal');
		},
		onFileChange2(e) {
			this.loadImage(e, 'imageUrl2', 'showModal2');
		},
		onFileChange3(e) {
			this.loadImage(e, 'imageUrl3', 'showModal3');
		},

		loadImage(event, urlKey, modalKey) {
			const file = event.target.files[0];
			if (file) {
				const reader = new FileReader();
				reader.onload = (e) => {
					this[urlKey] = e.target.result;
					this[modalKey] = true;
				};
				reader.readAsDataURL(file);
			}
		},

		cropImage(base64) {
			this.croppedImage = base64;
			this.showModal = false;
		},
		cropImage2(base64) {
			this.croppedImage2 = base64;
			this.showModal2 = false;
		},
		cropImage3(base64) {
			this.croppedImage3 = base64;
			this.showModal3 = false;
		},

		cancelCrop() {
			this.showModal = false;
		},
		cancelCrop2() {
			this.showModal2 = false;
		},
		cancelCrop3() {
			this.showModal3 = false;
		},
	}
};
</script>

<style scoped>
.error {
	color: red;
}
</style>